import React from 'react';
import { getAuthorizedComponent, updateComponentRoles } from 'src/store/slices/authorizationSlice';
import RoleAssignmentPanel from 'src/components/RoleAssignmentPanel';

const BASE_COLUMNS = [
  { field: 'COMPONENT_ID', headerName: 'Id', width: 80, align: 'center', headerAlign: 'center' },
  { field: 'COMPONENT_DESC', headerName: 'Alan / İşlem', flex: 1, minWidth: 220 }
];
const SEARCH_FIELDS = ['COMPONENT_DESC'];

function ComponentRoleAutho() {
  return (
    <RoleAssignmentPanel
      title="İşlem Yetkilendirme"
      unitLabel="işlem"
      loadAction={getAuthorizedComponent}
      updateAction={updateComponentRoles}
      buildPayload={(row, roles) => ({ ComponentRoles: roles, ComponentId: row.COMPONENT_ID })}
      getRowId={(row) => row.COMPONENT_ID}
      baseColumns={BASE_COLUMNS}
      searchFields={SEARCH_FIELDS}
      searchPlaceholder="Alan / işlem ara"
      getDialogInfo={(row) => ({ title: row.COMPONENT_DESC, subtitle: 'İşlemi kullanabilecek roller' })}
    />
  );
}

export default ComponentRoleAutho;
